import { strings } from "@/constants";

const TECHNICAL_PATTERNS = [
    /^HTTP\s+request/i,
    /method\s+not\s+allowed/i,
    /\{\s*["']detail["']/i,
    /^\s*\{[\s\S]*\}\s*$/,
    /^Error:/i,
    /^TypeError:/i,
    /^SyntaxError:/i,
    /^ReferenceError:/i,
    /\bstack\s*trace\b/i,
    /^\s*at\s+\w+\s*\(/m,
];

const NETWORK_PATTERNS = [
    /^Network\s+Error$/i,
    /failed\s+to\s+fetch/i,
    /ECONN(REFUSED|RESET|ABORTED)/i,
    /ETIMEDOUT/i,
];

const mapHttpStatusHandler = (code: number): string | null => {
    if (code === 401) return strings.errors.unauthorized;

    if (code === 403) return strings.errors.forbidden;

    if (code === 404) return strings.errors.notFound;

    if (code === 408) return strings.errors.requestTimeout;

    if (code === 429) return strings.errors.tooManyRequests;

    if (code >= 500) return strings.errors.serverError;

    if (code >= 400) return strings.errors.tryAgain;

    return null;
};

export const sanitizeErrorMessageHandler = (raw?: string | null): string => {
    if (!raw || typeof raw !== "string") return strings.errors.tryAgain;

    const trimmed = raw.trim();

    if (!trimmed) return strings.errors.tryAgain;

    if (NETWORK_PATTERNS.some((pattern) => pattern.test(trimmed))) return strings.errors.networkError;

    const statusMatch = trimmed.match(/(?:status\s*(?:code)?|HTTP)[\s:]*([0-9]{3})/i);

    if (statusMatch) {
        const friendly = mapHttpStatusHandler(Number(statusMatch[1]));

        if (friendly) return friendly;
    }

    if (TECHNICAL_PATTERNS.some((pattern) => pattern.test(trimmed))) return strings.errors.serverError;

    const firstLine = trimmed.split(/\r?\n/)[0].trim();

    if (firstLine.length > 200) return `${firstLine.slice(0, 200)}…`;

    return firstLine || strings.errors.tryAgain;
};
